import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c(VProgressCircular,{attrs:{"indeterminate":"","color":"primary"}}),_c('span',{staticClass:"ml-2"},[_vm._v(_vm._s(_vm.$t('common.loading')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }